import { ocTranslationsEn } from "./translations-en";
import { ocTranslationsHu } from "./translations-hu";
import { myCafeteriaTranslationsEn } from "my-cafeteria/configs/translations-en";
import { myCafeteriaTranslationsHu } from "my-cafeteria/configs/translations-hu";
import { myDocumentsTranslationsEn } from "my-documents/configs/translations-en";
import { myDocumentsTranslationsHu } from "my-documents/configs/translations-hu";
import { myHrTranslationsEn } from "my-hr/configs/translations-en";
import { myHrTranslationsHu } from "my-hr/configs/translations-hu";
import { myLeaveTranslationsEn } from "my-leave/configs/translations-en";
import { myLeaveTranslationsHu } from "my-leave/configs/translations-hu";
import { myNewsTranslationsEn } from "my-news/configs/translations-en";
import { myNewsTranslationsHu } from "my-news/configs/translations-hu";
import { myTaxTranslationsEn } from "my-tax/configs/translations-en";
import { myTaxTranslationsHu } from "my-tax/configs/translations-hu";
import { myTimeTranslationsEn } from "my-time/configs/translations-en";
import { myTimeTranslationsHu } from "my-time/configs/translations-hu";
import { myTimesheetTranslationsEn } from "my-timesheet/configs/translations-en";
import { myTimesheetTranslationsHu } from "my-timesheet/configs/translations-hu";

export const englishTranslations = {
  ...myCafeteriaTranslationsEn,
  ...myDocumentsTranslationsEn,
  ...myHrTranslationsEn,
  ...myLeaveTranslationsEn,
  ...myNewsTranslationsEn,
  ...myTaxTranslationsEn,
  ...myTimeTranslationsEn,
  ...myTimesheetTranslationsEn,
  ...ocTranslationsEn,
};

export const hungarianTranslations = {
  ...myCafeteriaTranslationsHu,
  ...myDocumentsTranslationsHu,
  ...myHrTranslationsHu,
  ...myLeaveTranslationsHu,
  ...myNewsTranslationsHu,
  ...myTaxTranslationsHu,
  ...myTimeTranslationsHu,
  ...myTimesheetTranslationsHu,
  ...ocTranslationsHu,
};
